module.exports = __webpack_public_path__ + "static/testimonials-9df046ff64691df1bbec73fd10c1c84f.jpeg";